import React from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  .pagination {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    gap: 4px;

    & .previous,
    & .next,
    & .pagination-li-item,
    & .break-me-li {
      & .pagination-item,
      & .break-me,
      & .arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 12px;
        border-radius: 8px;
        background-color: #ffffff;
        color: #767676;
        border: none;
        /* cursor: pointer; */

        &:hover {
          background-color: rgba(255, 255, 255, 0.5);
        }

        &.active {
          background-color: #3b3f51;
          color: #fff;
          font-weight: 600;
          border-radius: 8px;
          transform: scale(1.01);
          z-index: 2;
        }
      }

      & .arrow {
        border-radius: 50%;
        color: #3b3f51;
      }

      &.disabled {
        cursor: not-allowed;
        display: none;
      }
    }
  }
`;

export const Paginate = ({
  tableInstance,
  forcePage,
  // pageCount,
  pageRangeDisplayed,
  marginPagesDisplayed,
  onPageChange,
  onClick,
  onPageActive,
  disableInitialCallback,
  pageLabelBuilder,
  renderOnZeroPageCount
}) => {
  const { pageCount } = tableInstance;

  return (
    <PaginationContainer>
      <ReactPaginate
        forcePage={forcePage}
        pageCount={pageCount}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        // previousLabel='◄'
        // nextLabel='►'
        previousLabel=''
        nextLabel=''
        breakLabel='...'
        onPageChange={({ selected }) => {
          onPageChange(selected);
        }}
        onClick={onClick}
        onPageActive={onPageActive}
        disableInitialCallback={disableInitialCallback}
        pageLabelBuilder={pageLabelBuilder}
        renderOnZeroPageCount={renderOnZeroPageCount}
        breakClassName='break-me-li'
        breakLinkClassName='break-me'
        containerClassName='pagination'
        pageClassName='pagination-li-item'
        pageLinkClassName='pagination-item'
        activeLinkClassName='active'
        previousLinkClassName='arrow hr-Carret-left'
        nextLinkClassName='arrow hr-Carret-right'
      />
    </PaginationContainer>
  );
};

Paginate.defaultProps = {
  // forcePage: null,
  // initialPage: 0,
  pageCount: 0,
  pageRangeDisplayed: 4,
  marginPagesDisplayed: 2,
  onPageChange: () => {},
  onClick: () => {},
  onPageActive: () => {},
  disableInitialCallback: true,
  pageLabelBuilder: (page) => page,
  renderOnZeroPageCount: () => null
};
